const cache = new Map();

const buildKey = (key) => String(key || "");

export const cachedPromise = (key, fetcher, ttlMs = 60000) => {
  const now = Date.now();
  const cacheKey = buildKey(key);
  const existing = cache.get(cacheKey);

  if (existing && existing.expiresAt > now) {
    return existing.promise;
  }

  const promise = Promise.resolve()
    .then(fetcher)
    .then((data) => {
      cache.set(cacheKey, { expiresAt: now + ttlMs, promise: Promise.resolve(data) });
      return data;
    })
    .catch((err) => {
      const current = cache.get(cacheKey);
      if (current?.promise === promise) cache.delete(cacheKey);
      throw err;
    });

  cache.set(cacheKey, { expiresAt: now + ttlMs, promise });
  return promise;
};

export const cachedFetchJson = async (url, options = {}) => {
  const { ttlMs = 60000, fetchOptions } = options;
  return cachedPromise(
    `fetch:${url}`,
    async () => {
      const res = await fetch(url, fetchOptions);
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      return res.json();
    },
    ttlMs,
  );
};

export const cachedAxiosGet = (key, axiosGet, ttlMs = 60000) =>
  cachedPromise(key, axiosGet, ttlMs);
